export function footerMobileNav() {
    $('.footer-nav').find('> li').each(function () {
        let item = $(this);

        if (item.find("ul").length) {
            item.addClass('has-list').append('<i class="plus"></i>');
        }
    })
    $("body").on('click', '.plus', function (e) {
        e.preventDefault();
        $(this).parents('li').toggleClass('open').find("ul").slideToggle();
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/footerMobileNav.js